import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Title} from "@angular/platform-browser";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {SplashScreenService} from "./parts/splash-screen/splash-screen.service";
import UserService from '../api/user/user.service';
import ContextBarService from './parts/context-bar/context-bar.service';
import ReminderService from '../api/reminder.service';
import {environment} from '../environments/environment';

declare var $: any;

import Quill from 'quill';
import BlotFormatter from 'quill-blot-formatter';
import {AppCache} from "../cache";


const ATTRIBUTES = [
    'alt',
    'height',
    'width',
    'class', // this will allow the class attribute on the image tag
    'style',
    'data-align'
];

Quill.register('modules/blotFormatter', BlotFormatter);

const Image = Quill.import('formats/image');


const CustomImage = class CustomImage extends Image {
    static formats(domNode) {
        return ATTRIBUTES.reduce((formats, attribute) => {
            if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
            }
            return formats;
        }, {});
    }
    format(name, value) {
        console.log('format', name, value);
        if (ATTRIBUTES.indexOf(name) > -1) {
            if (value) {
                (this as any).domNode.setAttribute(name, value);
            } else {
                (this as any).domNode.removeAttribute(name);
            }
        } else {
            super.format(name, value);
        }
    }
}

Quill.register({
    // ... other formats
    'formats/image': CustomImage
});

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
    data = null;
    public opened: boolean = true;
    @ViewChild('splashScreen') splashScreen: ElementRef;

    public constructor(private titleService: Title,
                       private router: Router,
                       private reminderService: ReminderService,
                       private contextBarService: ContextBarService,
                       private splashScreenService: SplashScreenService,
                       private userService: UserService,
                       private route: ActivatedRoute) {
        this.titleService.setTitle('Lion CRM');
    }


    ngOnInit() {
        //$.getScript('assets/js/script.js');
        this.route.data.subscribe((data) => {});

        this.router.events.subscribe((evt) => {
          if (!(evt instanceof NavigationEnd)) {
            return;
          }
          // only do this when there is a context
          if(this.contextBarService.getCustomerSnapshot() != null ||
            this.contextBarService.getCooperationSnapshot() != null) {
            this.contextBarService.resetContext();
          }
          window.scrollTo(0, 0);
        });
    }

    removeSplashScreen() {
    }

    ngAfterViewInit() {
      setTimeout(() => {
        this.subscribeNotifications();
      }, 4000);
    }


  closeNav() {

    }

    openNav() {

    }

  public subscribeNotifications() {
    /*this.swPush.requestSubscription({
      serverPublicKey: environment.vapid_public_key
    })
      .then(sub => this.reminderService.addPushSubscriber(sub).subscribe())
      .catch(err => console.error('Could not subscribe to notifications', err));*/
  }
}
